import { marketplacesEnum } from '@/v2/utils/marketplaces';
import { api } from '../../../plugins/axios';
import { Alert } from '@/v2/plugins/alert';

export const marketplaceIdentifierType = Object.freeze({
	[marketplacesEnum.Amazon]: 'ASN',
});

export class Variants {
	id = undefined;
	product_id = undefined;
	related_product_variant_id = undefined;
	vendor_stock_code = undefined;
	barcode = undefined;
	quantity = undefined;
	price = undefined;
	currency_id = undefined;
	dsi = undefined;
	shipping_days = undefined;
	external_link = undefined;
	identifier_value = undefined;
	identifier_type = undefined;
	low_stock_quantity = undefined;
	cost = undefined;
	height = undefined;
	width = undefined;
	depth = undefined;
	price_after_discount = undefined;
	linked_marketplace_product = undefined;
	variant_images = [];
	discount = undefined;
	samePrice = true; // same price across all marketplaces
	central_stock = 1;
	linked_marketplaces_prices = [];
	linked_marketplaces_quantity = [];
	linked_marketplace_products = [];
	status = 'ACTIVE';
	option_values = [];

	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
		if (!this.variant_images) {
			this.variant_images = [];
		}

		if (this.linked_marketplaces_prices.length == 0) {
			this.linked_marketplaces_prices = this.linked_marketplace_products.map((item) => ({
				linked_marketplace_id: item.linked_marketplace_id,
				variant_id: this.id,
				selling_price: item.selling_price,
				cost_price: item.cost_price,
				discounted_price: item.discounted_price,
				lowest_price: item.lowest_price,
				highest_price: item.highest_price,
				discount_start_at: item.discount_start_at,
				discount_end_at: item.discount_end_at,
				identifier_type: item.identifier_type || marketplaceIdentifierType[item.marketplace_id],
				identifier_value: item.identifier_value,
			}));
		}

		if (this.linked_marketplaces_quantity.length == 0) {
			this.linked_marketplaces_quantity = this.linked_marketplace_products.map((item) => ({
				linked_marketplace_id: item.linked_marketplace_id,
				quantity: item.quantity,
			}));
		}

		if (!this.option_values) this.option_values = [];
	}

	static async getVariantsQuantity(id) {
		const { data } = await api.get(`/products/link/${id}/link-variant-quantity`);

		return data.result;
	}

	static async searchVariants(id, params) {
		const { data } = await api.get(`/products/link/${id}/link-variant-quantity/search`, {
			params,
		});

		return data.result;
	}

	static async linkVariants(id, data) {
		await api.post(`/products/link-variant-quantity/${id}`, data);
	}
	static async unlinkVariants(id) {
		await api.post(`/products/unlink-variant-quantity/${id}`);
	}

	async update(data) {
		try {
			await api.put(`/products/update-variant/${this.id}`, data);
		} catch (err) {
			if (err?.response?.data?.message) {
				Alert.error(err?.response?.data?.message);
			}
			throw err;
		}
	}

	static async updateBatch(variants, saveAndList = false) {
		try {
			await api.put('/products/update-variants-batch', { variants, save_and_list: saveAndList });
		} catch (err) {
			if (err?.response?.data?.message) {
				Alert.error(err?.response?.data?.message);
			}
			throw err;
		}
	}

	static addImage(data) {
		return api.post(`/products/variant_images`, data);
	}

	static deleteImage(id, params) {
		return api.delete(`/products/variant_images/${id}`, { params });
	}

	static async create(data) {
		try {
			const res = await api.post(`/products/store-variant`, data);
			return new Variants(res.data.result.variant);
		} catch (err) {
			if (err?.response?.data?.message) {
				Alert.error(err?.response?.data?.message);
			}
			throw err;
		}
	}

	static async checkSku(sku) {
		const res = await api.get('/variants/validate-sku', { params: { sku } });
		return res.data;
	}
}
